import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';
import Editor from 'components/composers/SMSComposer';
import MessageAttachment from './MessageAttachment';

const SMSComposer = ({
  attachment,
  message,
  onChange,
  onAttachmentSelect,
  id = 'sms_editor',
  height,
  disabled,
  aiActions,
}) => {
  const [t] = useTranslation(['messages']);

  const removeAttachment = () => onAttachmentSelect();

  return (
    <Box>
      <Editor
        multiSegmentWarning
        messageSizeWarning
        maxSegments={3}
        value={message}
        id={id}
        onChange={onChange}
        placeholder="Hi {FIRST_NAME}..."
        onFileSelect={onAttachmentSelect}
        height={height ?? 300}
        disabled={disabled}
        aiActions={aiActions}
      />
      {attachment && (
        <Box mt={2} maxWidth={300}>
          <Typography fontWeight={500} variant="body2" sx={{ mb: 1 }}>
            {t('sms-composer-attached-image', 'Attached media for this SMS')}
          </Typography>
          <MessageAttachment
            hash={attachment.location}
            name={attachment.file_name}
            onRemove={removeAttachment}
          />
        </Box>
      )}
      <Box mb={2}>
        {attachment && (
          <Alert severity="info" sx={{ mt: 1 }}>
            {t(
              'sms-media-delivery-warning',
              'Heads up! Attachments may reduce delivery. Media counts as 1 extra message.',
            )}
          </Alert>
        )}
      </Box>
    </Box>
  );
};

export default SMSComposer;
